export default __webpack_public_path__ + "static/youjoh1-25795e1ad4ac873999616fff274e85ce.jpg";